import React, { createContext, useContext, useState } from 'react';

export const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const getBrowserLang = () => {
    const lang = navigator.language || navigator.userLanguage || 'en';
    return lang.startsWith('de') ? 'de' : 'en';
  };

  const [lang, setLang] = useState(() => {
    return localStorage.getItem('docudi_lang') || getBrowserLang();
  });

  const switchLang = (l) => {
    setLang(l);
    localStorage.setItem('docudi_lang', l);
  };

  return (
    <LanguageContext.Provider value={{ lang, switchLang }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  return useContext(LanguageContext);
}
